module.exports = __webpack_public_path__ + "static/media/Brunette Male_1599237230365.77163c60.png";